import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const LeaderboardComponent = React.lazy(() => import('./components/Leaderboard'));

const Leaderboard = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <LeaderboardComponent />
      </Suspense>
    </div>
  );
};

export default Leaderboard;
